import { type InferResponseType, unwrap } from "@nexxt/api-client";
import { filterQuery } from "@nexxt/app-kit";
import type { ListCustomerFulfillmentsInput } from "@nexxt/contracts/logistics";
import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query";
import { api } from "../../api";

// Server state of the shipments of the customer's orders (ADR-220): one factory, the same keys for the loaders and the
// screens.

const fulfillments = api.logistics.fulfillments;

type ListPage = InferResponseType<typeof fulfillments.$get, 200>;
export type CustomerShipment = ListPage["items"][number];

/** The filters of the list (`listCustomerFulfillmentsInput`), without the paging the query adds. */
export type ShipmentFilters = Pick<ListCustomerFulfillmentsInput, "q" | "salesOrder">;

const PAGE_SIZE = 25;

export const shipmentQueries = {
  all: ["shipments"] as const,

  list: (filters: ShipmentFilters) =>
    infiniteQueryOptions({
      queryKey: ["shipments", "list", filters],
      queryFn: ({ pageParam, signal }) =>
        unwrap(
          fulfillments.$get(
            { query: { ...filterQuery(filters), page: String(pageParam), pageSize: String(PAGE_SIZE) } },
            { init: { signal } },
          ),
        ),
      initialPageParam: 1,
      getNextPageParam: (last) => (last.hasMore ? last.page + 1 : undefined),
    }),

  /** One shipment with its parcels; 404 for one of another customer. */
  detail: (fulfillmentId: string) =>
    queryOptions({
      queryKey: ["shipments", "detail", fulfillmentId],
      queryFn: ({ signal }) =>
        unwrap(fulfillments[":fulfillmentId"].$get({ param: { fulfillmentId } }, { init: { signal } })),
    }),
};
